import Modal from '../common/Modal'
import Button from '../common/Button'
import ProjectStore from '../../store/projectStore'
import Loader from '../common/Loader'
import {observer} from 'mobx-react';

const ProjectDeleteModal = (props) => (
    <Modal isOpen={props.isOpen} onClose={() => ProjectStore.setDeleteModalVisible(false)}>
        <Modal.Header>{__('Remove')}</Modal.Header>
        <Modal.Body>
            {ProjectStore.duringDelete && <Loader fillContainer={true}/>}
            {__('Do you want to remove this project?')}
        </Modal.Body>
        <Modal.Footer>
            <Button theme={Button.Theme.BorderOnly}
                    onClick={() => ProjectStore.setDeleteModalVisible(false)}>{__('Cancel')}</Button>
            <Button theme={Button.Theme.BorderOnly} onClick={() => props.onDeleteClick()}>{__('Remove')}</Button>
        </Modal.Footer>
    </Modal>
)

const ProjectEditPage = observer(ProjectDeleteModal)
export default ProjectEditPage;